import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'

/**
 * 创建并导出 router 实例
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
